import * as React from "react";

export const FlagItaly = () => <span>🇮🇹</span>;
